<div class="accounts-container">
  <div class="accounts-header">
    <div>
      <h1>{{ 'ACCOUNTS_TITLE' | translate }}</h1>
      <p>{{ 'ACCOUNTS_SUBTITLE' | translate }}</p>
    </div>
    <button class="action-button" mat-button primary [disabled]="isLoading" (click)="loadAccounts()">
      <mat-icon svgIcon="refresh" class="material-icon-fixed"></mat-icon>
      <span class="text">{{ 'REFRESH' | translate }}</span>
    </button>
  </div>

  <form class="account-enroll-form" [formGroup]="form">
    <rezolve-numeric-input
      required="true"
      formControlName="accountNumber"
      [label]="'ACCOUNTS_FORM.ACCOUNT_NUMBER' | translate"
      [maxLength]="18"
      [placeholder]="'ACCOUNTS_FORM.ACCOUNT_NUMBER_PLACEHOLDER' | translate"
      [errorDescriptions]="{
        required: 'REQUIRED' | translate,
        pattern: 'ACCOUNTS_FORM.ACCOUNT_NUMBER_LENGTH_ERROR' | translate
      }">
    </rezolve-numeric-input>

    <button
      type="button"
      class="action-button enroll-account-button"
      mat-button
      primary
      (click)="enrollAccount()">
      <span class="text">{{ 'ACCOUNTS_FORM.ADD_ACCOUNT' | translate }}</span>
    </button>

  </form>

  <rezolve-search-input
    [placeholder]="'SEARCH' | translate"
    (textChange)="applySearchTerm($event)">
  </rezolve-search-input>

  <div class="accounts-list">
    <div class="accounts-table-container">
      <table mat-table class="base-table accounts-table" [dataSource]="dataSource" matSort matSortDisableClear width="100%">
        <ng-container matColumnDef="createdOn">
          <th mat-header-cell *matHeaderCellDef mat-sort-header width="18%">
            {{ 'ACCOUNTS_TABLE.CREATED_ON' | translate }}
          </th>
          <td mat-cell class="base-table-cell" *matCellDef="let account">{{ account.createdOn | date: 'dd/MM/yyyy' }}</td>
        </ng-container>

        <ng-container matColumnDef="accountNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header width="28%">
            {{ 'ACCOUNTS_TABLE.ACCOUNT_NUMBER' | translate }}
          </th>
          <td mat-cell class="base-table-cell" *matCellDef="let account">{{ account.accountNumber || '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="validationAttempts">
          <th mat-header-cell *matHeaderCellDef mat-sort-header width="22%">
            {{ 'ACCOUNTS_TABLE.VALIDATION_ATTEMPTS' | translate }}
          </th>
          <td mat-cell class="base-table-cell" *matCellDef="let account">{{ account.validationAttempts }}</td>
        </ng-container>

        <ng-container matColumnDef="validationStatus">
          <th mat-header-cell *matHeaderCellDef mat-sort-header width="22%">
            {{ 'ACCOUNTS_TABLE.VALIDATION_STATUS' | translate }}
          </th>
          <td mat-cell class="base-table-cell" *matCellDef="let account">
            {{ account.validationStatusTranslationKey ? (account.validationStatusTranslationKey | translate) : '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef width="16%"></th>
          <td mat-cell class="base-table-cell-actions" *matCellDef="let account">
            <button
              *ngIf="account.validationStatus === 'ValidationFailed'"
              class="retry-validation-button"
              mat-button
              primary
              [matTooltip]="'ACCOUNTS_TABLE.RETRY_VALIDATION' | translate"
              (click)="retryAccountValidation(account)">
              {{ 'ACCOUNTS_TABLE.RETRY_VALIDATION' | translate }}
            </button>
          </td>
        </ng-container>

        <tr mat-header-row class="base-table-header" *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row class="base-table-row" *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <rezolve-list-pagination
        [itemsLength]="filteredAccountsLength"
        [currentPage]="currentPage"
        [itemsPerPage]="itemsPerPage"
        [pageSizeOptions]="pageSizeOptions"
        (pageChanged)="onPageChanged($event)"
        (pageSizeChanged)="onPageSizeChanged($event)">
      </rezolve-list-pagination>

      <div class="empty-state" *ngIf="!isLoading && filteredAccountsLength === 0">
        {{ 'ACCOUNTS_TABLE.EMPTY' | translate }}
      </div>

      <div class="accounts-spinner-container" *ngIf="isLoading || isEnrollAccountLoading || isRetryAccountValidationLoading">
        <mat-spinner></mat-spinner>
      </div>
    </div>
  </div>
</div>
